import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const CheckIcon: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 24 18">
    <path
      d="M2.063 7.65l6.334 6.358L21.932.435l1.717 1.709L8.397 17.387.347 9.345z"
      fillRule="evenodd"
    />
  </IconBase>
);
